import { sendGet } from './../helpers/axiosSso';

export const getInforUser = (params) => sendGet('/api/user/auth', params);
